import React from "react";

const Bathroom = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        d="M9.59961 16H7.59961C7.04732 16 6.59961 16.4477 6.59961 17V21C6.59961 21.5523 7.04732 22 7.59961 22H9.59961M9.59961 16V19M9.59961 16H13.5996M9.59961 22H18.5996C19.1519 22 19.5996 21.5523 19.5996 21V19M9.59961 22V19M9.59961 19H19.5996M19.5996 19V17C19.5996 16.4477 19.1519 16 18.5996 16H13.5996M9.59961 13C9.59961 12.3333 9.99961 11 11.5996 11C13.1996 11 13.5996 12.3333 13.5996 13V16M17.5996 13H20.5996C21.1519 13 21.5996 12.5523 21.5996 12V3C21.5996 2.44771 21.1519 2 20.5996 2H4.59961C4.04733 2 3.59961 2.44772 3.59961 3V12C3.59961 12.5523 4.04732 13 4.59961 13H5.59961"
        stroke="#00A3BC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Bathroom;
